import { QueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../query-keys';

export const resetQuantaQueries = (queryClient: QueryClient) => {
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaLogin] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaCheck] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaMissions] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaSideMissions] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaMissionTasks] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaSideMissionTasks] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaRanking] });
};
